import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  ref,
} from "vue";

import BaseButton from "@/components/buttons/BaseButton.vue";

import {
  FileDownload,
} from "@/scripts/Common/FileDownload";

import {
  useI18n,
} from "@/composables/useI18n";

import {
  CardImportResult,
} from "@/components/cards/scripts";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportCustomersResultDialog',
  props: {
  importResult: {
    required: true,
    type: Object as PropType<CardImportResult>,
  },
},
  setup(__props, { expose }) {

const props = __props;

const {
  t,
} = useI18n();



const isVisible = ref<boolean>(false);

const show = () => {
  isVisible.value = true;
};

const hide = () => {
  isVisible.value = false;
};

const onHandleConfirm = () => {
  hide();
};

const onHandleDownload = () => {
  if (!!props.importResult.failedImports && props.importResult.failedImports > 0) {
    FileDownload.Create(props.importResult.incorrectLinesAsCsv, t("CsvFileName").toString());
  }
};

expose({
  show,
})


return { __sfc: true,t, props, isVisible, show, hide, onHandleConfirm, onHandleDownload, BaseButton }
}

})